module.exports = __webpack_public_path__ + "static/media/error-page-bottom-right-cloud.dec836b3.svg";